import { getNotificationPreferences, updateNotificationPreferences, } from "./auth/AuthGate";
function urlBase64ToUint8Array(base64) {
    const padding = "=".repeat((4 - (base64.length % 4)) % 4);
    const base64Safe = (base64 + padding).replace(/-/g, "+").replace(/_/g, "/");
    const raw = window.atob(base64Safe);
    return Uint8Array.from([...raw].map((char) => char.charCodeAt(0)));
}
export async function registerServiceWorker() {
    if (!("serviceWorker" in navigator))
        return null;
    return navigator.serviceWorker.register("/sw.js");
}
// Ensures a push subscription exists on the server for this browser, requesting notification
// permission first if needed.
export async function ensurePushSubscription() {
    if (!("serviceWorker" in navigator) || !("PushManager" in window))
        return "unsupported";
    await registerServiceWorker();
    const registration = await navigator.serviceWorker.ready;
    if (Notification.permission === "denied")
        return "denied";
    let subscription = await registration.pushManager.getSubscription();
    if (!subscription) {
        const permission = await Notification.requestPermission();
        if (permission !== "granted")
            return "denied";
        const res = await fetch("/api/notifications/vapid-public-key", {
            credentials: "include",
        });
        const { publicKey } = (await res.json());
        if (!publicKey)
            return "unsupported";
        subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(publicKey),
        });
    }
    await fetch("/api/notifications/subscribe", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(subscription.toJSON()),
    });
    return "granted";
}
// Preferences default to notifyOwnBuildings: true server-side, so a fresh account can already
// have a notification "on" without a subscription ever having been requested. Called once when
// the game starts (rather than from the settings switches) so the permission prompt shows up
// front instead of only when the player happens to open Settings.
export async function ensureNotificationPermissionForCurrentPreferences() {
    const prefs = await getNotificationPreferences();
    if (!prefs.notifyOwnBuildings && !prefs.notifyOthersBuildings)
        return;
    const permission = await ensurePushSubscription();
    if (permission === "granted")
        return;
    // Permission wasn't granted — don't leave preferences claiming otherwise.
    const revert = {};
    if (prefs.notifyOwnBuildings)
        revert.notifyOwnBuildings = false;
    if (prefs.notifyOthersBuildings)
        revert.notifyOthersBuildings = false;
    await updateNotificationPreferences(revert).catch(() => { });
}
